import React from 'react';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';
import Link from '@mui/material/Link';

import contactAssocGroupStyles from '../assets/jss/crm/components/contactAssocGroupStyles';

import DA from '../store/ReduxAccess';
import ContactSummary from './ContactSummary';
import NewClientContactModal from './NewClientContactModal';
import NewFirmContactModal from './NewFirmContactModal';

class ContactAssocGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      exposureLevel: 'showActiveContacts',
      showNewFirmContactModal: false,
      showNewClientContactModal: false,
      dummyRefreshCounter: 0,
    };
  }

  toggleContactsVisibility() {
    const newLevel = this.state.exposureLevel === 'showNoContacts' ? 'showActiveContacts' : 'showNoContacts';
    this.setState({ exposureLevel: newLevel });
  }

  showAllContacts() {
    this.setState({ exposureLevel: 'showAllContacts' });
  }

  showUIToAddNewContact(event) {
    event.stopPropagation();
    if (this.props.contactType === 'firm') {
      this.setState({ showNewFirmContactModal: true });
    } else {
      this.setState({ showNewClientContactModal: true });
    }
  }

  rerender(newExposureLevel) {
    if (newExposureLevel) {
      this.setState({ exposureLevel: newExposureLevel });
    } else {
      this.setState({ dummyRefreshCounter: this.state.dummyRefreshCounter + 1 });
    }
  }

  createContactSummaries(contacts) {
    const contactsToShow =
      this.state.exposureLevel === 'showAllContacts' ? contacts : contacts.filter((contact) => !contact.inactive);
    const referrerOrg = this.props.referrerOrgId ? DA.getFirmById(this.props.referrerOrgId) : null;
    return (
      <div>
        {contactsToShow.map((contact) => (
          <ContactSummary
            key={contact.personId}
            contact={contact}
            referrerOrg={referrerOrg}
            clientId={this.props.clientId}
            refreshFunc={(newExposureLevel) => this.rerender(newExposureLevel)}
          />
        ))}
      </div>
    );
  }

  createShowMoreRow(contacts) {
    const { classes } = this.props;
    const inactiveContacts = contacts.filter((contact) => contact.inactive);
    const nInactive = inactiveContacts.length;
    if (nInactive === 0) return null;
    return (
      <div className={cx(classes.entityAssocGroup_showMoreRow, classes.ac_h6)} onClick={() => this.showAllContacts()}>
        <Link underline="hover">
          View {' ' + nInactive + ' '} inactive {nInactive === 1 ? 'contact ' : 'contacts '}
          <i className={'zmdi zmdi-chevron-down'} />
        </Link>
      </div>
    );
  }

  closeNewContactModal() {
    this.setState({ showNewFirmContactModal: false });
    this.setState({ showNewClientContactModal: false });
    this.props.updateFunc();
  }

  render() {
    const { classes, contactsFunc } = this.props;
    const contacts = contactsFunc() || [];

    return (
      <div>
        <NewFirmContactModal
          show={this.state.showNewFirmContactModal}
          viewingFirmId={this.props.viewingFirmId}
          visibleFirmId={this.props.referrerOrgId}
          successFunc={() => this.closeNewContactModal()}
          closeModalFunc={() => this.closeNewContactModal()}
        />
        <NewClientContactModal
          show={this.state.showNewClientContactModal}
          viewingFirmId={this.props.viewingFirmId}
          clientId={this.props.clientId}
          successFunc={(newContactId) => this.closeNewContactModal()}
          closeModalFunc={() => this.closeNewContactModal()}
        />
        <div className={classes.entityAssocGroup}>
          <div className={classes.entityAssocGroup_header} onClick={() => this.toggleContactsVisibility()}>
            <div className={classes.quickAddToggle} onClick={(event) => this.showUIToAddNewContact(event)}>
              <div className={classes.addOneButton + ' ' + classes.button_icon}>
                <i className="zmdi zmdi-plus" />
              </div>
            </div>
            <div className={classes.entityAssocGroup_title + ' ' + classes.ac_h4}>
              Contacts ({contacts.length})&nbsp;
              {contacts.length ? (
                <i
                  className={cx(
                    classes.entityAssocGroup_expand,
                    'zmdi',
                    { 'zmdi-chevron-right': this.state.exposureLevel === 'showNoContacts' },
                    { 'zmdi-chevron-down': this.state.exposureLevel !== 'showNoContacts' }
                  )}
                />
              ) : null}
            </div>
          </div>
          {this.state.exposureLevel !== 'showNoContacts' && this.createContactSummaries(contacts)}
          {this.state.exposureLevel === 'showActiveContacts' && this.createShowMoreRow(contacts)}
        </div>
      </div>
    );
  }
}

export default withStyles(contactAssocGroupStyles)(ContactAssocGroup);
